import { render } from "./cart-button.vue?vue&type=template&id=155846d3"
import script from "./cart-button.vue?vue&type=script&lang=js"
export * from "./cart-button.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__